import s from '@corratech/pylot-custom-widgets/ExperienceGroup/Experience.module.scss'
import React from 'react'

import { getFastlyUrl } from '@corratech/pylot-image'

type WidgetConfiguration = {
    widgetConfiguration: { [key: string]: string }
    childCount?: number
}
const ExperienceCard = (props: WidgetConfiguration) => {
    const {
        childCount,
        widgetConfiguration: { content, image, imageFastlyParam }
    } = props

    const getfastlyConfig = () => {
        if (imageFastlyParam) {
            return JSON.parse(imageFastlyParam)
        }
        return { width: 570, height: 570 }
    }
    const fastlyImageUrl = getFastlyUrl({
        src: image,
        ...getfastlyConfig()
    })

    return (
        <div className={s['landing-page-about-slide']}>
            {/* eslint-disable-next-line i18next/no-literal-string */}
            <img src={fastlyImageUrl} alt="Experience card" loading="lazy" />
            <span>{childCount}</span>
            <p>{content}</p>
        </div>
    )
}
export default ExperienceCard
